module.exports = __webpack_public_path__ + "img/12.76a64795.png";